import { useState, useEffect } from 'react';
import TeamsSDK, { TeamsContext } from '@/teams/TeamsSDK';

export type Platform = 'teams' | 'web';

export interface PlatformInfo {
  platform: Platform;
  teamsContext: TeamsContext | null;
  isReady: boolean;
}

export function usePlatform(): PlatformInfo {
  const [platform, setPlatform] = useState<Platform>('web');
  const [teamsContext, setTeamsContext] = useState<TeamsContext | null>(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      const isInIframe = window !== window.top;
      if (isInIframe) {
        try {
          const teamsInit = TeamsSDK.initialize();
          const timeout = new Promise<never>((_, reject) =>
            setTimeout(() => reject(new Error('Teams SDK timeout')), 2000)
          );
          await Promise.race([teamsInit, timeout]);

          TeamsSDK.notifyAppLoaded();
          const ctx = await TeamsSDK.getContext();
          if (ctx) {
            TeamsSDK.markInTeams();
            setPlatform('teams');
            setTeamsContext(ctx);
            TeamsSDK.notifySuccess();
          }
        } catch {
          // Not in Teams or SDK failed — use web mode
        }
      }
      setIsReady(true);
    };

    init();
  }, []);

  return { platform, teamsContext, isReady };
}
